import { KYMW4000Component } from './kymw4000.component';

/**
 * 週次プロモーション商品計画表画面の値を管理するクラス
 *
 * @export KYMW4000Model
 * @class KYMW4000Model
 */
export class KYMW4000Model {

  kymw4000Component: KYMW4000Component;

  // 画面バインド用変数
  public startOrderCode: string = <string>'';                                    // 受注コード（開始）
  public endOrderCode: string = <string>'';                                      // 受注コード（終了）
  public promotionNo: string = <string>'';                                       // プロモーション番号

}
